import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  CRYPTO_CREATE,
  CRYPTO_DELETE,
  CRYPTO_FETCH,
  CRYPTO_UPDATE,
  M_DELETE,
  M_GET,
  M_POST,
  M_PUT,
} from '@/utils/api';

import Vue from 'vue';
import { ICryptoAccount } from '@/interface/CryptoInterface';

@Module({ name: 'cryptoaccount' })
export default class CryptoAccount extends VuexModule {
  @Action
  FetchCryptoAccount() {
    return Vue.axios({
      url: BASE_URL + CRYPTO_FETCH,
      data: '',
      method: M_GET,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  CreateCryptoAccount(params: ICryptoAccount) {
    return Vue.axios({
      url: BASE_URL + CRYPTO_CREATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateCryptoAccount(params: ICryptoAccount) {
    return Vue.axios({
      url: BASE_URL + CRYPTO_UPDATE,
      data: params,
      method: M_PUT,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  DeleteCryptoAccount(params: ICryptoAccount) {
    return Vue.axios({
      url: BASE_URL + CRYPTO_DELETE,
      data: params,
      method: M_DELETE,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
